import React from "react";
import { PATHS } from "../../../config/permissionsPaths";
import useAuth from "../../../hooks/useAuth";
import { PatientInput, InputWrapper, InputIcons } from "../Home.styles";
import icons from "../../../assets/icons/iconMap";
import SearchableSelect from "../../../components/Common/SearchableSelect";

const PatientSearchInput = ({
  selectTipoIdRef,
  inputUnicIdRef,
  tipoUnicId,
  setTipoUnicId,
  unicId,
  setUnicId,
  tiposIdentificacion,
  handleInputChange,
  handleKeyDown,
  handleClearAll,
  fetchPatientData,
  getPacienteExterno,
  exportPacienteExterno,
  canExportPaciente,
  openSearchModal,
  openModal,
}) => {
  const { hasPermission } = useAuth();

  return (
    <InputWrapper>
      <span style={{ fontWeight: "500", whiteSpace: "nowrap" }}>
        Datos del paciente (ID)
      </span>

      {/* Select de Tipo de Identificación */}
      <SearchableSelect
        ref={selectTipoIdRef}
        value={tipoUnicId}
        onValueChange={(val) => {
          setTipoUnicId(val);
          setTimeout(() => inputUnicIdRef.current?.focus(), 0);
        }}
        options={tiposIdentificacion}
        getOptionValue={(t) => t.Codigo}
        getOptionLabel={(t) => (t.Descripcion ? `${t.Codigo} - ${t.Descripcion}` : t.Codigo)}
        placeholder="Seleccione tipo"
        multiple={false}
        searchable={true}
        sx={{
          width: "220px",
          minWidth: "160px",
          maxWidth: "240px",
          mr: "12px",
          "& .MuiOutlinedInput-root": {
            height: "31px",
            minHeight: "31px",
            borderRadius: "var(--radius-sm)",
            fontSize: "var(--app-font-size)",
            fontFamily: "var(--font-body)",
            bgcolor: "var(--color-surface-base)",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "var(--border-medium)",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--color-accent)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--color-accent)",
            boxShadow: "0 0 0 3px rgba(3, 105, 161, 0.15)",
          },
        }}
        selectSx={{
          height: "31px",
          minHeight: "31px",
          "& .MuiSelect-select": {
            padding: "4px 8px !important",
            fontSize: "var(--app-font-size)",
            fontFamily: "var(--font-body)",
            color: "var(--color-text-title)",
          },
        }}
      />

      {/* Input de ID del Paciente */}
      <PatientInput
        type="text"
        placeholder="Ingrese ID del paciente"
        value={unicId}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        ref={inputUnicIdRef}
        aria-label="ID del paciente"
      />

      {/* Iconos de Acciones */}
      <InputIcons>
        {/* Buscar Paciente */}
        <img
          src={icons["enter"]}
          alt="Buscar paciente"
          title="Aceptar (Enter)"
          style={{ width: 18, height: 18, cursor: "pointer" }}
          onClick={fetchPatientData}
        />

        {/* Mostrar Lista de Pacientes */}
        <img
          src={icons["search"]}
          alt="Buscar paciente"
          title="Buscar paciente"
          style={{ width: 18, height: 18, cursor: "pointer" }}
          onClick={openSearchModal}
        />

        {/* Limpiar Vista */}
        <img
          src={icons["eraser"]}
          alt="Limpiar"
          title="Limpiar vista"
          style={{ width: 18, height: 18, cursor: "pointer" }}
          onClick={handleClearAll}
        />

        {/* Importar de SIOS - Solo con permiso */}
        {hasPermission(PATHS.IMPORTAR_PC_SIOS) && (
          <img
            src={icons["addUser"]}
            alt="Importar"
            title="Importar pacientes desde historia clínica"
            style={{ width: 18, height: 18, cursor: "pointer" }}
            onClick={getPacienteExterno}
          />
        )}

        {hasPermission(PATHS.IMPORTAR_PC_SIOS) && (
          <img
            src={icons["login"]}
            alt="Exportar"
            title={
              canExportPaciente
                ? "Exportar paciente a la base externa de la sede"
                : "Consulte un paciente local para habilitar la exportación"
            }
            style={{
              width: 18,
              height: 18,
              cursor: canExportPaciente ? "pointer" : "not-allowed",
              opacity: canExportPaciente ? 1 : 0.45,
            }}
            onClick={canExportPaciente ? () => exportPacienteExterno() : undefined}
            aria-disabled={!canExportPaciente}
          />
        )}

        {/* Ver Gráficas - Solo con permiso */}
        {hasPermission(PATHS.VER_GRAFICAS) && (
          <img
            src={icons["book"]}
            alt="Gráficas"
            title="Ver Gráfica de Grupos"
            style={{
              width: 20,
              height: 20,
              cursor: "pointer",
              marginLeft: "auto",
            }}
            onClick={() => openModal("group")}
          />
        )}
      </InputIcons>
    </InputWrapper>
  );
};

export default PatientSearchInput;
